/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table, TableBody, TableCell, TableContainer, TableRow,
  TextField, Typography, Button, Paper, Checkbox, Tooltip, ButtonGroup, FormControl, InputLabel, Select, MenuItem,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import CommonTableToolbar from '../../CommonComponents/TableComponents/CommonTableToolBar';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import {
  CommonButton, CommonModal,
} from '../../CommonComponents';
import {
  getVendorUsers,
  assignVendorToSite,
  assignFrequencyToSites,
  changeStartDate,
  removeMapping,
  removeFrequency,
  changeEndDate,
} from '../../redux/actions/sites';
import AssignSite from './AssignSite';
import AssignFrequency from './AssignFrequency';
import FallbackCard from '../../CommonComponents/FallbackCard';
import CommonAlert from '../../CommonComponents/CommonAlert';

const title = 'All sites list';

const headCells = [
  {
    id: 'siteId',
    numeric: false,
    disablePadding: true,
    label: 'Site Id',
  },
  {
    id: 'mediaTypeName',
    numeric: true,
    disablePadding: false,
    label: 'Media',
  },
  {
    id: 'stateName',
    numeric: true,
    disablePadding: false,
    label: 'State',
  },
  {
    id: 'cityName',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'locationName',
    disablePadding: false,
    label: 'Location',
    width: '20%',
  },
  {
    id: 'startDate',
    numeric: true,
    disablePadding: false,
    label: 'Start Date',
  },
  {
    id: 'endDate',
    numeric: true,
    disablePadding: false,
    label: 'End Date',
  },
  {
    id: 'supplierName',
    numeric: true,
    disablePadding: false,
    label: 'Supplier',
  },
  {
    id: 'FlexReceiveDate',
    numeric: true,
    disablePadding: false,
    label: 'Flex Receive Date',
  },
  {
    id: 'frequency',
    numeric: true,
    disablePadding: false,
    label: 'Frequency',
  },
  {
    id: 'monitor',
    numeric: true,
    disablePadding: false,
    label: 'Monitor',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    marginLeft: 20,
  },
  searchBar: {
    float: 'right',
    width: '100%',
  },
  formControl: {
    marginBottom: theme.spacing(1),
    minWidth: 120,
    width: '100%',
  },
}));

const EnhancedTable = ({
  allSites, currentPageCount, getUsers, assignUser, assignFrequency,
  changeDate, removeMonitor, selected, setSelected, setCheckbox, checkBoxState,
  removeFreq, selectedStartDate, setSelectedStartDate,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('SiteId');
  const [page] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [frequencyModal, setFrequencyModal] = useState(false);
  const [startDateModal, setStartDateModal] = useState(null);
  const [updateMultipleDate, updateMultipleStartDate] = useState(false);
  const [assignInfo, setAssignInfo] = useState({});
  const [user, selectedUser] = useState(null);
  const [frequency, selectedFrequency] = useState(null);
  const [dates, selectedDates] = useState([]);
  const [newStartDate, setNewStartDate] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [showFrequencyAlert, setFrequencyAlert] = useState(false);

  const allEndDates = Array.from(new Set(allSites.map((row) => (row.newStartDate ? row.newStartDate : row.startDate))))
  const filter = allEndDates.map((row) => ({
    text: row,
    value: row,
  }))

  const filteredSites = selectedStartDate ? allSites.filter((row) => (row.newStartDate ? row.newStartDate : row.startDate) === selectedStartDate) : allSites

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (checkBoxState) {
      if (event.target.checked) {
        const newSelecteds = filteredSites
          .filter((n) => n.frequency === null && n.id)
          .map((obj) => obj.id);
        setSelected(newSelecteds);
        setCheckbox(false);
      }
    } else {
      setCheckbox(true);
      setSelected([]);
    }
  };

  const handleSelectAllClickVendor = (event) => {
    if (checkBoxState) {
      if (event.target.checked) {
        const newSelecteds = filteredSites.map((obj) => obj.id);
        setSelected(newSelecteds);
        setCheckbox(false);
      }
    } else {
      setCheckbox(true);
      setSelected([]);
    }
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleAssignUser = (rows) => {
    getUsers(rows.supplierId)
    setAssignInfo(rows);
    setModalOpen(true);
  };

  const handleDismissModal = () => {
    setAssignInfo({});
    setModalOpen(false);
  };

  const assignUserToSite = () => {
    const data = {
      siteId: [assignInfo.id],
      vendorUserId: user,
    }
    assignUser(data);
    setAssignInfo({});
    setModalOpen(false);
  }

  const assingFrequencyToSites = () => {
    const data = {
      siteId: selected,
      frequency,
    }
    if (frequency === 'CustomDate') {
      data.customDates = [...dates]
    }
    assignFrequency(data);
    setCurrentRow(null)
    setFrequencyModal(false);
    setSelected([])
  }

  const handleSet = (event, row) => {
    handleClick(event, row.id)
    setCurrentRow(row)
    setFrequencyModal(true);
  }

  const handleDayClick = (day) => {
    setNewStartDate(day)
  }

  const changeSiteStartDate = () => {
    const siteId = updateMultipleDate ? selected : [startDateModal.id];
    changeDate({
      siteId,
      newStartDate,
    })
    setNewStartDate(null)
    setStartDateModal(null)
    setSelected([])
    updateMultipleStartDate(false)
  }

  const removeAssignment = () => {
    removeMonitor(showAlert);
    setShowAlert(false);
  }

  const removeFrequencyAssignment = () => {
    removeFreq(showFrequencyAlert);
    setFrequencyAlert(false);
  }
  const userType = JSON.parse(localStorage.getItem('user'));
  const numSelected = selected.length;
  return (
    <div className={classes.root}>
      {allSites.length > 0 ? (
        <div>
          <Paper className={classes.paper}>
            <CommonTableToolbar>
              <div className="row fluid">
                <div className="col-7">
                  {numSelected > 0 ? (
                    <Typography
                      className={classes.title}
                      color="primary"
                      variant="subtitle1"
                      component="div"
                    >
                      {numSelected > 1
                        ? `${numSelected} sites selected `
                        : `${numSelected} site selected `}
                    </Typography>
                  ) : (
                    <Typography
                      className={classes.title}
                      variant="h6"
                      id="tableTitle"
                      component="div"
                    >
                      {title}
                    </Typography>
                  )}
                </div>
                <div className="col-4 ml-auto">
                  <TextField
                    className={classes.searchBar}
                    id="outlined-basic"
                    label="Search this page"
                    variant="outlined"
                  />
                </div>
              </div>
            </CommonTableToolbar>
            <div className="row">
              {userType && (userType.userType === 'admin' || userType.userType === 'manager' || userType.userType === 'clientUser')
                ? (
                  <>
                    <div className="ml-2">
                      <CommonButton
                        className={classes.assignButtonWidth}
                        disabled={numSelected === 0 || userType.userType === 'clientUser'}
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => setFrequencyModal(true)}
                      >
                        Assign Frequency
                      </CommonButton>
                    </div>
                    <div className="">
                      <CommonButton
                        className={classes.assignButtonWidth}
                        disabled={numSelected === 0 || userType.userType === 'clientUser'}
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => updateMultipleStartDate(true)}
                      >
                        Change Start Date
                      </CommonButton>
                    </div>
                    <div className="col-2">
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel>Filter by Start Date</InputLabel>
                        <Select
                          value={selectedStartDate}
                          onChange={(event) => {
                            setSelected([]);
                            setSelectedStartDate(event.target.value);
                          }}
                          autoWidth
                          label="Filter by Start Date"
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {filter.map((option) => (
                            <MenuItem key={option.text} value={option.value}>
                              {option.text}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                  </>
                )
                : null}
            </div>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={userType && (userType.userType === 'admin' || userType.userType === 'manager' || userType.userType === 'clientUser') ? handleSelectAllClick : handleSelectAllClickVendor}
                  onRequestSort={handleRequestSort}
                  rowCount={allSites.length}
                  checkbox
                  selected={allSites.filter((itm) => itm.frequency !== null).length}
                />
                <TableBody>
                  {stableSort(filteredSites, getComparator(order, orderBy))
                    .slice(
                      page * currentPageCount,
                      page * currentPageCount + currentPageCount,
                    )
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            {userType && (userType.userType === 'admin' || userType.userType === 'manager' || userType.userType === 'clientUser')
                              ? (
                                <Checkbox
                                  color="primary"
                                  checked={row.frequency || isItemSelected}
                                  disabled={!!row.frequency}
                                  inputProps={{ 'aria-labelledby': labelId }}
                                  onChange={(event) => handleClick(event, row.id)}
                                />
                              )
                              : (
                                <Checkbox
                                  color="primary"
                                  checked={isItemSelected}
                                  inputProps={{ 'aria-labelledby': labelId }}
                                  onChange={(event) => handleClick(event, row.id)}
                                />
                              )}
                          </TableCell>
                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none"
                          >
                            {row.siteId}
                          </TableCell>
                          <TableCell>{row.mediaTypeName}</TableCell>
                          <TableCell>{row.stateName}</TableCell>
                          <TableCell>{row.cityName}</TableCell>
                          <TableCell>{row.locationName}</TableCell>
                          <TableCell
                            align="center"
                            padding="none"
                          >
                            {userType && (userType.userType === 'admin' || userType.userType === 'manager' || userType.userType === 'clientUser')
                              ? (
                                <>
                                  {!row.frequency ? (
                                    <Tooltip title="Click to change start date" placement="top" arrow>
                                      <Button
                                        className="p-0"
                                        basic="true"
                                        color="primary"
                                        disabled={selected.length > 1 || userType.userType === 'clientUser'}
                                        onClick={() => setStartDateModal(row)}
                                      >
                                        {moment(row.newStartDate ? row.newStartDate : row.startDate).format('DD MMM YYYY')}
                                      </Button>
                                    </Tooltip>
                                  )
                                    : (
                                      moment(row.newStartDate ? row.newStartDate : row.startDate).format('DD MMM YYYY')
                                    )}
                                </>
                              ) : (moment(row.newStartDate ? row.newStartDate : row.startDate).format('DD MMM YYYY'))}
                          </TableCell>
                          <TableCell align="center" padding="none">
                            {moment(row.newEndDate ? row.newEndDate : row.endDate).format('DD MMM YYYY')}
                          </TableCell>
                          <TableCell>{row.supplierName}</TableCell>
                          <TableCell>{row.flexReceivedDate ? moment(row.flexReceivedDate).format('DD MMM YYYY') : ''}</TableCell>
                          <TableCell>
                            {userType && (userType.userType === 'admin' || userType.userType === 'manager' || userType.userType === 'clientUser')
                              ? (
                                <>
                                  {row.frequency ? (
                                    <>
                                      {row.submittedReports === 0
                                        ? (
                                          <ButtonGroup variant="contained" color="primary" aria-label="split button">
                                            <Button>{row.frequency}</Button>
                                            <Tooltip title="Click to remove frequency" placement="top" arrow>
                                              <Button
                                                color="primary"
                                                size="small"
                                                aria-label="remove mapping"
                                                aria-haspopup="menu"
                                                disabled={userType.userType === 'clientUser'}
                                                onClick={() => setFrequencyAlert(row.id)}
                                              >
                                                <ClearIcon />
                                              </Button>
                                            </Tooltip>
                                          </ButtonGroup>
                                        )
                                        : row.frequency}
                                    </>
                                  ) : (
                                    <CommonButton
                                      onClick={(e) => handleSet(e, row)}
                                      basic="true"
                                      color="primary"
                                      disabled={selected.length > 1 || userType.userType === 'clientUser'}
                                    >
                                      Set
                                    </CommonButton>
                                  )}
                                </>
                              )
                              : row.frequency}
                          </TableCell>
                          <TableCell>
                            {userType && (userType.userType === 'admin' || userType.userType === 'manager' || userType.userType === 'clientUser')
                              ? (
                                <>
                                  {
                                row.monitor === null
                                  ? (
                                    <CommonButton
                                      onClick={() => handleAssignUser(row)}
                                      basic="true"
                                      color="primary"
                                      disabled={userType.userType === 'clientUser'}
                                    >
                                      Assign
                                    </CommonButton>
                                  )
                                  : (
                                    <>
                                      <ButtonGroup variant="contained" color="primary" aria-label="split button">
                                        <Button>{row.monitor}</Button>
                                        {row.submittedReports === 0
                                          ? (
                                            <Tooltip title="Click to remove mapping" placement="top" arrow>
                                              <Button
                                                color="primary"
                                                size="small"
                                                aria-label="remove mapping"
                                                aria-haspopup="menu"
                                                disabled={userType.userType === 'clientUser'}
                                                onClick={() => setShowAlert(row.id)}
                                              >
                                                <ClearIcon />
                                              </Button>
                                            </Tooltip>
                                          )
                                          : null }
                                      </ButtonGroup>
                                    </>
                                  )
                              }
                                </>
                              )
                              : (row.monitor)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          {modalOpen && (
            <CommonModal
              title="Assign Vendor User"
              open
              width="md"
              onYes={assignUserToSite}
              onClose={handleDismissModal}
              successButtonText="Assign"
              cancelButtonText="Cancel"
            >
              <AssignSite row={assignInfo} selectedUser={selectedUser} />
            </CommonModal>
          )}
          {frequencyModal && (
            <CommonModal
              title="Set Frequency"
              open
              width="md"
              onYes={assingFrequencyToSites}
              onClose={() => {
                setCurrentRow(null);
                setFrequencyModal(false);
              }}
              successButtonText="Assign"
              cancelButtonText="Cancel"
            >
              <AssignFrequency
                selectedFrequency={selectedFrequency}
                selectedDates={selectedDates}
                estimateStartDate={currentRow
                  && (currentRow.newStartDate ? currentRow.newStartDate : currentRow.startDate)}
                estimateEndDate={currentRow && (currentRow.newEndDate ? currentRow.newEndDate : currentRow.endDate)}
              />
            </CommonModal>
          )}
          {startDateModal && (
            <CommonModal
              title="Change Start Date"
              open
              width="md"
              onYes={changeSiteStartDate}
              onClose={() => {
                setNewStartDate(null);
                setStartDateModal(null);
              }}
              saveBtnDisable={!newStartDate}
              successButtonText="Change"
              cancelButtonText="Cancel"
            >
              <p className="mb-1">
                Original start date is
                {' '}
                {startDateModal.startDate}
              </p>
              {startDateModal.newStartDate ? (
                <p className="mb-1">
                  Previous Updated start date is
                  {' '}
                  {startDateModal.newStartDate}
                </p>
              ) : null }
              <DayPicker
                disabledDays={[
                  {
                    after: new Date(moment(startDateModal.startDate).format('YYYY'), moment(startDateModal.startDate).format('MM') - 1, moment(startDateModal.startDate).format('DD') - 1),
                    before: new Date(moment(startDateModal.startDate).format('YYYY'), moment(startDateModal.startDate).format('MM') - 1, moment(startDateModal.startDate).format('DD') - 12),
                  }]}
                selectedDays={newStartDate}
                onDayClick={handleDayClick}
              />
            </CommonModal>
          )}

          {updateMultipleDate && (
            <CommonModal
              title="Change Start Date"
              open
              width="md"
              onYes={changeSiteStartDate}
              onClose={() => {
                setNewStartDate(null);
                updateMultipleStartDate(false);
              }}
              saveBtnDisable={!newStartDate}
              successButtonText="Change"
              cancelButtonText="Cancel"
            >
              <p className="mb-1">Note:- The new start date should not be older then 12 days of the original start date.</p>
              <DayPicker
                selectedDays={newStartDate}
                onDayClick={handleDayClick}
              />
            </CommonModal>
          )}

          {showAlert
            ? (
              <CommonAlert
                title="Are you sure?"
                description="It will remove assinged monitor of this site."
                onClose={() => setShowAlert(false)}
                onAgree={removeAssignment}
              />
            )
            : null}

          {showFrequencyAlert
            ? (
              <CommonAlert
                title="Are you sure?"
                description="It will remove assinged frequency of selected sites."
                onClose={() => setFrequencyAlert(false)}
                onAgree={removeFrequencyAssignment}
              />
            )
            : null}
        </div>
      ) : (
        <FallbackCard text="No data found" />
      )}
    </div>
  );
};

const mapState = (state) => ({
  allSites: state.sites.allSites,
  currentPageCount: state.sites.currentPageCount,
});

const mapActions = {
  getUsers: getVendorUsers,
  assignUser: assignVendorToSite,
  assignFrequency: assignFrequencyToSites,
  changeDate: changeStartDate,
  changeEDate: changeEndDate,
  removeMonitor: removeMapping,
  removeFreq: removeFrequency,
};

export default connect(mapState, mapActions)(EnhancedTable);
